// extracted by mini-css-extract-plugin
export default {"arrowContainer":"styles-module__arrowContainer__src-labstep-web-components-Entity-Table-SortOptions-Order-_l6gS5"};